import styles from './stores-page.module.scss'
import cl from 'classnames'
import { observer } from 'mobx-react-lite'
import { PageContainer } from 'components'
import { Button, ImagePortrait, Input, PageHeader, PaginationButtons, RatingStars, Select } from '@touche-lts/panel-ui/dist'
import { useRootStore } from 'mobx-stores/store-provider'
import { useEffect, useState } from 'react'
import { StoresSortBy } from 'models/stores'
import { UserRoleName } from 'models/user'
import { getMyStorePath } from 'routes'
import { User } from 'services'

const StoresPageComponent = () => {
  const defaultImageSrc =
      "https://st2.depositphotos.com/4403291/7418/v/600/depositphotos_74189661-stock-illustration-online-shop-log.jpg",
    {
      storesPublic: {
        getAllStores,
        paginationInfo,
        onPageSelect,
        setPaginationProps,
        pageStores,
        onSearchStore,
        StoreSortBy,
        selectedStoreSortingSelected,
        setStoreSorting,
      },
      userStore: { assignedStoreId },
      routingStore: { push }
    } = useRootStore(),
    [searchStore, setSearchStore] = useState<string>(""),
    searchHandle = (search: string) => {
      setSearchStore(search);
      onSearchStore(search);
    },
    handleProductViewRedirect = (productCount: number, storeId: number) => {
      if (!!productCount) {
        push(`/stores/${storeId}`);
      }
    },
    isSuperAdmin = JSON.parse(localStorage.getItem('userDetails'))?.role?.name === UserRoleName.SUPER_ADMIN

  useEffect(() => {
    // Store admins go directly to their own store page
    if (User.isStoreAdmin && assignedStoreId) {
      push(`/stores/${assignedStoreId}`)
      return
    }
    getAllStores({ resetPageNumber: true })
    onPageSelect(0)
  }, [getAllStores, onPageSelect, assignedStoreId, push])

  return (
    <PageContainer className={cl(styles.scrollable, styles.storePageContainer)}>
      <div className={styles.storesPageWrapper}>
        {!User.isAuthenticated && <div className={styles.storesBackground} />}
        <PageHeader
          navSegments={[
            {
              label: "All stores",
            },
          ]}
          colorPreset="dark"
          className={styles.pageHeader}
        />
        <div className={styles.storesPageSearchContainer}>
          <div className={styles.storesPageSearchInputContainer}>
            <Input
              colorPreset="dark"
              placeholder="Search for a store..."
              value={searchStore}
              onChange={(search) => searchHandle(search)}
              className={styles.storeSearchInputContainer}
            />
          </div>
          <div className={cl(styles.selectStoreWrapper)}>
            <div className={styles.selectStore}>
              <p className={styles.storeSortBy}>Sort by </p>
              <Select<StoresSortBy>
                colorPreset="dark"
                options={StoreSortBy}
                noNoneOption
                value={selectedStoreSortingSelected}
                placeholder="Actions"
                className={cl(styles.selectRootClassName, styles.sortDropdown)}
                onChange={(
                  type, // TODO-A To add a type
                ) => setStoreSorting(type)}
              />
            </div>
          </div>
        </div>
        <div className={styles.storesContainer}>
          {pageStores &&
            pageStores.content.map((store) => {
              // TODO-A To add model type
              return (
                <div
                  key={store.id}
                  onClick={() =>
                    handleProductViewRedirect(store.productCount, store.id)
                  }
                  className={styles.storeInfo}
                >
                  <div className={styles.storeInfoDetails}>
                    <ImagePortrait
                      width={56}
                      height={80}
                      src={
                        !!store?.squareCrop
                          ? store?.squareCrop?.url
                          : defaultImageSrc
                      }
                    />
                    <div className={styles.storeInfoDetailsText}>
                      <h2>{store.name}</h2>
                      <RatingStars
                        rating={store.rating}
                        reviewsCnt={store.reviewsCnt}
                      />
                      <small>{store.productCount} products</small>
                      {isSuperAdmin && (
                        <Button
                          preset='secondary'
                          onClick={(event) => {
                            event.stopPropagation()
                            push(getMyStorePath(store.id))
                          }}
                        >
                          Manage store
                        </Button>
                      )}
                    </div>
                  </div>
                </div>
              );
            })}
        </div>
        <PaginationButtons
          colorPreset="dark"
          alwaysShow
          className={styles.paginationButtonsContainer}
          {...paginationInfo}
          onPageSelect={onPageSelect}
        />
      </div>
    </PageContainer>
  );
};

const StoresPage = observer(StoresPageComponent);
export { StoresPage };
